module.exports = __webpack_public_path__ + "static/media/8.37df32ae.jpg";